export function getFinancialDetailsEndpoint(contractId: string, productTypeId: string): string {
    return `/contracts/${contractId}/${productTypeId}/financial-details`;
}
